// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! muse-css:product:tIx4-6 */\nbutton.G82Tj{max-width:7.8rem}button.gs28W{max-width:4.25rem}@media (min-width:768px){button.gs28W{max-width:7.8rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"followButton": "G82Tj",
	"followButtonNarrow": "gs28W"
};
export default ___CSS_LOADER_EXPORT___;
